export const PartnerEndpoints = {
  login: "/api/v1/partners/login",
  twoFactorSetup: "/api/v1/partners/2fa/setup",
  twoFactorActivate: "/api/v1/partners/2fa/activate",
  twoFactorVerify: "/api/v1/partners/2fa/verify",

  // The backend docs write this as /v1/partner/dashboard; the /api prefix is what setupProxy strips.
  dashboard: "/api/v1/partner/dashboard",
  partnerDetails: "/api/v1/partner/details",
  transactions: "/api/v1/partner/transactions",
  transactionsExport: "/api/v1/partner/transactions/export",
  payouts: "/api/v1/partner/payouts",
  webhookLogs: "/api/v1/partner/webhook-logs",
  externalUsers: "/api/v1/partner/external-users",
  generateCredentials: "/api/v1/partner/generate-credentials",
  changePassword: "/api/v1/partner/change-password",
  editWebhook: "/api/v1/partner/change-webhook",
  rotateWebhookSecret: "/api/v1/partner/rotate-webhook-secret",
  whitelistIp: "/api/v1/partner/whitelist-ip",
  removeIp: "/api/v1/partner/remove-ip",

  myPermissions: "/api/v1/partner/me/permissions",
  team: "/api/v1/partner/team",
  teamRoles: "/api/v1/partner/team/roles",
  teamMember: (userId) => `/api/v1/partner/team/${userId}`,
  teamMemberStatus: (userId) => `/api/v1/partner/team/${userId}/status`,
  resendTeamInvite: (userId) => `/api/v1/partner/team/${userId}/resend-invite`,

  subMerchants: "/api/v1/partner/sub-merchants",
  subMerchant: (id) => `/api/v1/partner/sub-merchants/${id}`,
  subMerchantStatus: (id) => `/api/v1/partner/sub-merchants/${id}/status`,
  subMerchantPans: (id) => `/api/v1/partner/sub-merchants/${id}/pans`,
  subMerchantPan: (id, pan) => `/api/v1/partner/sub-merchants/${id}/pans/${pan}`,
  subMerchantUsers: (id) => `/api/v1/partner/sub-merchants/${id}/users`,
  subMerchantUser: (id, userId) => `/api/v1/partner/sub-merchants/${id}/users/${userId}`,
  subMerchantUserStatus: (id, userId) => `/api/v1/partner/sub-merchants/${id}/users/${userId}/status`,
  subMerchantUserResend: (id, userId) => `/api/v1/partner/sub-merchants/${id}/users/${userId}/resend-invite`,
  subMerchantLedger: (id) => `/api/v1/partner/sub-merchants/${id}/ledger`,
  subMerchantWithdrawals: (id) => `/api/v1/partner/sub-merchants/${id}/withdrawals`,

  ownDashboard: "/api/v1/partner/sub-merchant/dashboard",
  ownPans: "/api/v1/partner/sub-merchant/pans",
  ownTransactions: "/api/v1/partner/sub-merchant/transactions",
  ownTransactionsExport: "/api/v1/partner/sub-merchant/transactions/export",
  ownLedger: "/api/v1/partner/sub-merchant/ledger",
  ownBanks: "/api/v1/partner/sub-merchant/banks",
  ownBankAccount: "/api/v1/partner/sub-merchant/bank-account",
  ownWithdrawals: "/api/v1/partner/sub-merchant/withdrawals",

  agentProfile: "/api/v1/merchants/agent/profile",
  agentCommissionsSummary: "/api/v1/merchants/agent/commissions/summary",
  agentTransactions: "/api/v1/merchants/agent/transactions",
  agentCommissions: "/api/v1/merchants/agent/commissions",
};

export const EnterpriseEndpoints = {
  dashboard: "/api/v1/enterprise/dashboard",
  transactions: "/api/v1/enterprise/transactions",
  transactionsExport: "/api/v1/enterprise/transactions/export",
  ledger: "/api/v1/enterprise/ledger",
  payouts: "/api/v1/enterprise/payouts",
  payoutsAll: "/api/v1/enterprise/payouts/all",
  payoutQuote: "/api/v1/enterprise/payouts/quote",
  bankAccount: "/api/v1/enterprise/bank-account",
  merchants: "/api/v1/enterprise/merchants",
  merchant: (id) => `/api/v1/enterprise/merchants/${id}`,
  merchantTransactions: (id) => `/api/v1/enterprise/merchants/${id}/transactions`,
  merchantTransactionsExport: (id) => `/api/v1/enterprise/merchants/${id}/transactions/export`,
  users: "/api/v1/enterprise/users",
  user: (id) => `/api/v1/enterprise/users/${id}`,
  userStatus: (id) => `/api/v1/enterprise/users/${id}/status`,
  userResendInvite: (id) => `/api/v1/enterprise/users/${id}/resend-invite`,
};
